import React from "react";
import "./App.scss";
import ChatBot from "./ChatBot";

function App() {
  return (
    <div className="App">
      <ChatBot />
    </div>
  );
}

export default App;
